import { Outlet } from "react-router-dom";
import withReducer from "app/store/withReducer";
import reducer from "./store";

const ContactSupportApp = () => {
  return <Outlet />;
};

export default withReducer("supportApp", reducer)(ContactSupportApp);
